// N38 · Phase 3.3 — 助手台词框架：预写台词模板 + 槽位填充（纯函数，方便加台词/改语气）
// 约定：confirm/ask/fixAsk 这类"等用户操作"的台词以问句收尾；done/cancel 是收场白。

export const lines = {
  greet: () =>
    '嗨，说一句话我帮你记～ 例：「早上9点到10点吃早饭」「刚才19点14分拉屎了」「6点吃晚饭备注一下久号食堂」',

  confirm: (plan) => {
    const note = plan.note ? `，备注「${plan.note}」` : '';
    const cross = plan.crossMidnight ? '（跨午夜，0 点后的部分写到明天）' : '';
    const conflict = plan.conflicts.count > 0
      ? ` 注意：该时段已有「${plan.conflicts.names.join('」「')}」共 ${plan.conflicts.count} 格，确认会覆盖。`
      : '';
    return `好嘞——今天 ${plan.timeLabel} · ${plan.catName}${note}${cross}，对吗？${conflict}`;
  },

  ask: (word) => `「${word}」算哪个分类？选一个，下次我就直接认了～`,

  learned: (word, catName) => `记住啦：「${word}」→ ${catName}，下次直接认。`,

  fixWhat: () => '改哪里？',

  fixAsk: (alias) => `「${alias}」改成哪个分类？改了以后都按新的认。`,

  fixNoteAsk: (note) => (note ? `现在的备注是「${note}」，直接改吧～` : '要加什么备注？直接打～'),

  done: (plan) => `✓ 已记上 今天 ${plan.timeLabel} · ${plan.catName}${plan.note ? `（${plan.note}）` : ''}`,

  cancel: () => '好，当我没说～',

  ttsOn: () => '好，我说话啦～',

  suggest: (prevName, names) => (prevName
    ? `上一件是「${prevName}」～接下来可以：${names.join(' / ')}？点下面一键记到当前时段。`
    : `现在可以：${names.join(' / ')}～点下面一键记到当前时段。`),

  failTime: () => '没听懂时间…试试「9点到10点」「下午3点」「刚才半小时」这类说法',

  failActivity: () => '没认出活动词…加上「吃饭 / 睡觉 / 跑步 / 看书」这类词试试',

  reparseFail: () => '记住了，但这句还是没解析出来，换个说法试试？',
};
